var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { type, defaultValue, Component, Schema } from "./decorators/type.js";
import { d as CollisionCategoryEnum } from "./enums-86f58524.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let RigidCircleSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "radius");
    __publicField(this, "bodyId");
    __publicField(this, "isStatic");
    __publicField(this, "isSensor");
    __publicField(this, "mass");
    __publicField(this, "disabled");
    __publicField(this, "directionLock");
    __publicField(this, "velocityLock");
    __publicField(this, "collisionCategory");
    __publicField(this, "collisionEvents");
    __publicField(this, "collisionMask");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidCircleSchema.prototype, "radius", 2);
__decorateClass([
  type("number")
], RigidCircleSchema.prototype, "bodyId", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "isStatic", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "isSensor", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], RigidCircleSchema.prototype, "mass", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "disabled", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "directionLock", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "velocityLock", 2);
__decorateClass([
  type(CollisionCategoryEnum),
  defaultValue(CollisionCategoryEnum.DEFAULT)
], RigidCircleSchema.prototype, "collisionCategory", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidCircleSchema.prototype, "collisionEvents", 2);
__decorateClass([
  type(["number"])
], RigidCircleSchema.prototype, "collisionMask", 2);
RigidCircleSchema = __decorateClass([
  Component("RigidCircle")
], RigidCircleSchema);
let RigidCircleResolverSchema = class extends Schema {
};
RigidCircleResolverSchema = __decorateClass([
  Component("RigidCircleResolver")
], RigidCircleResolverSchema);
const __vite_glob_0_22 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RigidCircleResolverSchema() {
    return RigidCircleResolverSchema;
  },
  get RigidCircleSchema() {
    return RigidCircleSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  RigidCircleSchema as R,
  __vite_glob_0_22 as _,
  RigidCircleResolverSchema as a
};
//# sourceMappingURL=RigidCircle-ee2bcb73.js.map
